import { Pipe, type PipeTransform } from '@angular/core';

function splitDomainPart(domainPart: string): [string, string] {
  const lastDot = domainPart.lastIndexOf('.');
  return [domainPart[0], domainPart.slice(lastDot, domainPart.length)];
}

export function getPrivateEmail(email: string): string {
  const [namePart, domainPart] = email.split('@');
  const [domain, tld] = splitDomainPart(domainPart);
  const firstChar = namePart[0];
  return `${firstChar}***@${domain}***${tld}`;
}

@Pipe({
  name: 'privateEmail',
})
export class PrivateEmailPipe implements PipeTransform {
  transform(value: string): string {
    return getPrivateEmail(value);
  }
}
